import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_EHROrderConfiguration } from '@app/org-shared';
export const dispatch_onEHROrderConfigurationChanged = new ThunderDispatcherV3('__onEHROrderConfigurationUpdated');
export class ModuleFE_EHROrderConfiguration_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_EHROrderConfiguration, dispatch_onEHROrderConfigurationChanged);
        this._v1 = {};
    }
}
export const ModuleFE_EHROrderConfiguration = new ModuleFE_EHROrderConfiguration_Class();
//# sourceMappingURL=ModuleFE_EHROrderConfiguration.js.map